module.exports = __webpack_public_path__ + "static/media/txt-icon.79abf009.svg";